import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_BACKGROUND_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_FORM_BACKGROUND_TYPE = 'postermywall-form-background';
// The signup tree's card keeps this base id; the confirmation/error cards get -2/-3 suffixes.
export const SIGNUP_CONTAINER_ID = 'postermywall-signup-container';
const DATA_ATTR = 'data-is-pmw-form-background';

export const POSTERMYWALL_FORM_BACKGROUND: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'DIV' && el.getAttribute(DATA_ATTR) !== null ? {type: POSTERMYWALL_FORM_BACKGROUND_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'div',
      toolbar: [],
      name: window.i18next.t('pmwjs_form_maker_name_form_background'),
      icon: 'icon-background',
      selectable: true,
      highlightable: false,
      hoverable: true,
      badgable: true,
      removable: false,
      draggable: false, // locked: dragging out orphans the card and breaks the public popup
      droppable: false,
      style: FORM_BACKGROUND_STYLES,
      attributes: {
        [DATA_ATTR]: '1',
        'data-pmw-type': POSTERMYWALL_FORM_BACKGROUND_TYPE,
        id: SIGNUP_CONTAINER_ID,
      },
    },
  },
};
